import { render, staticRenderFns } from "./Hizmet.vue?vue&type=template&id=5e6284d1&lang=true&"
import script from "./Hizmet.vue?vue&type=script&lang=js&"
export * from "./Hizmet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports